import { useQuery } from "react-query";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { OlapScoresQuery } from "src/context/OlapScores/useOlapScoresParams";
import { OlapScoresWithPrevScoresSchema } from "./olapScoresSchema";

export const getProductScoresKey = "getProductScores" as const;

type Options = {
    productId: number | undefined;
    companyId: number | undefined;
    campaignId: number | undefined;
    scoresQuery?: OlapScoresQuery;
    enabled?: boolean;
};

export const useGetProductScores = (options: Options) => {
    const { productId, companyId, campaignId, scoresQuery, enabled = true } = options;

    return useQuery({
        queryKey: [getProductScoresKey, productId, companyId, campaignId, scoresQuery],
        enabled: enabled && productId !== undefined && campaignId !== undefined,
        staleTime: 5 * 60 * 1000,
        queryFn: async () => {
            const url = `/api/products/${productId}/campaign/${campaignId}/scores`;

            return await loggedInApiCall.get(url, {
                params: {
                    ...scoresQuery,
                    organization_id: companyId,
                },
            });
        },
        select: (request) => {
            const data = zodParseWithDetailedLog(request.data, OlapScoresWithPrevScoresSchema, {
                operation: "GET",
                endpoint: "/products/:id/campaign/:campaignId/scores",
            });
            return data;
        },
    });
};
